import { render } from "./Submenu.vue?vue&type=template&id=0837636a"
import script from "./Submenu.vue?vue&type=script&lang=js"
export * from "./Submenu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\carbon_gitlab\\mvgx-carbon-rating-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__